import Natural from "./Natural"

class BankerNatural extends Natural {

}

export default BankerNatural
